import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../../helper/api";
import { GoArrowRight, GoChevronLeft, GoChevronRight } from "react-icons/go";

import { useDispatch, useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import {
  useOutsideAlerter,
  handleSidebarDrawerInit,
  getCookies,
  getReadableDate,
  bottomSideBarList,
  navItems,
  // navSportsItems,
  sideBarListNew,
} from "../../helper/utils";
import GameListComponent from "../../components/game-list-navbar";
import { useTheme } from "../../routes/private-route";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoMdRefresh } from "react-icons/io";
import coin from "../../assets/images/Frame 1597880683 (1).png";
import { fetchUserBalance } from "../../redux/slices/profile/fetchUserBalanceSlice";
import { config } from "../../redux/slices/auth/configSlice";
import { getProfile } from "../../redux/slices/profile/fetchProfileSlice";
import { getAllNotification } from "../../redux/slices/notification/getAllNotificationSlice";
import { markSeen } from "../../redux/slices/notification/markSeenSlice";
import { markSeenAll } from "../../redux/slices/notification/markSeenAllSlice";
import UserProfile from "../../assets/images/my-account.svg";
import UserProfileIcon from "../../assets/images/bet-frenzy/icons/auth/username43a0.svg";
import Logo from "../../assets/images/bet-frenzy/Betfrenzy Logo Transparent.png";
import LogoMobile from "../../assets/images/bet-frenzy/LogoMobile.png";
import Notification from "../../assets/images/bet-frenzy/header/notifications4b6d.svg";
import INR from "../../assets/images/bet-frenzy/header/INR.svg";
import Logout from "../../assets/images/svgs/back 1.svg";
import Search from "../../assets/images/bet-frenzy/casino/search43a0.svg";
import casinoMain from "../../assets/images/bet-frenzy/icons/casino43a0.svg";
import sportsMain from "../../assets/images/bet-frenzy/icons/sport43a0.svg";
import liveCasinoMain from "../../assets/images/bet-frenzy/icons/livecasino43a0.svg";
import eSports from "../../assets/images/bet-frenzy/icons/game.png";
import Cricket from "../../assets/images/bet-frenzy/icons/cricket 1.svg";
import Promotions from "../../assets/images/bet-frenzy/icons/promos43a0.svg";
import Racing from "../../assets/images/bet-frenzy/menu-icons/categories/racing5ed3.svg";
import Aviator from "../../assets/images/bet-frenzy/menu-icons/categories/aviator5ed3.gif";
import Gifting from "../../assets/images/bet-frenzy/header/gift4b6d.svg";
import vipClub from "../../assets/images/bet-frenzy/rake-back_1.png";
import tournaments from "../../assets/images/bet-frenzy/tournaments.png";
import InstantGames from "./instant-games";
import {
  LogoutModal,
  LoginModal,
  SignupModal,
  ForgotPINModal,
  WalletModal,
  MFAModal,
  RakebackModal,
} from "../../components";

import SportsFilter from "./filterCheckbox";
import selecteCasino from "../../assets/images/comingSoon/casino2.svg";
import selectedLivesacino from "../../assets/images/comingSoon/livecasino2.svg";
import selectedSports from "../../assets/images/comingSoon/sport2.svg";
import { getDreamCasinoGames } from "../../redux/slices/games/casino/dreamCasinoGameListSlice";
import PlayModePopup from "../../components/common/PlayModePopup";
import eventEmitter from "../../events/eventEmitter";
import { getSocket } from "../../helper/socket";

const HumburgerMenu = ({ menuOpen, setMenuOpen }) => {
  const { toggleTheme } = useTheme(); // setGameSearch
  const auth = getCookies("betfrenzy_token");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [selectHour, setSelectHour] = useState("");
  const [query, setQuery] = useState("");
  const [expand, setExpand] = useState(false);
  const [providerData, setProviderData] = useState([]);
  const { t, i18n } = useTranslation();
  const [category, setCategory] = useState({
    casino: [],
    live: [],
    sports: [],
  });
  const { error: profileError, data: profileData } = useSelector(
    (state) => state.getProfile
  );
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const socket = getSocket();

  useEffect(() => {
    const handleCallUser = (message) => {
      if (message) {
        setBalance(message?.userBalance);
        setGiftWalletBalance(message?.giftWallet);
      }
    };

    const handleToggleSportsMenu = (isActive) => {
      setIsSportGame(isActive);
    };

    // Set up the socket listener for 'callUser'
    socket?.on("callUser", handleCallUser);

    eventEmitter.on("toggleSportsMenu", handleToggleSportsMenu);

    // Clean up the socket listener on component unmount
    return () => {
      socket?.off("callUser", handleCallUser);
      eventEmitter.off("toggleSportsMenu", handleToggleSportsMenu);
    };
  }, [socket]); // Run this effect whenever the socket instance changes

  const handleGameClick = () => {
    console.log("handleGameClick");
    if (!profileData) {
      setLoginOpen(true);
      return;
    }

    const game = category?.sports?.[0]; // Example: cricket
    setSelectedGame(game);

    setIsPopupOpen(true);
  };

  const fromLogin =
    location.state?.fromLogin || sessionStorage.getItem("fromLogin") == "true";
  const isMobile = window.innerWidth <= 992;

  const configData = useSelector((state) => state.config.data);
  const [selected, setSelected] = useState("all");
  const [currentPage, setCurrentPage] = useState("");
  const [isToggled, setIsToggled] = useState(false);
  const [hoverProfile, setHoverProfile] = useState(false);
  const [hoverTheme, setHoverTheme] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [logoutModal, setLogoutModal] = useState(false);
  const [open, setOpen] = useState(menuOpen);
  const [notificationToggle, setNotificationToggle] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isForgotPINOpen, setForgotPINOpen] = useState(false);
  const [balance, setBalance] = useState();
  const { innerWidth: width } = window;
  const [lang, setLang] = useState("en");
  const [isRakebackModalOpen, setIsRakebackModalOpen] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isSignupOpen, setSignupOpen] = useState(false);

  const [isWalletOpen, setIsWalletOpen] = useState(false);
  const [isMFAOpen, setIsMFAOpen] = useState(false);

  const [submenuOpen, setsubMenuOpen] = useState(false);
  const [sidebarToggled, setSidebarToggled] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [gamesWithBg1, setGamesWithBg1] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryCount, setCategoryCount] = useState([
    { name: "Casino", count: 0 },
    { name: "Live Casino", count: 0 },
    { name: "Sports", count: 0 },
    { name: "E Sports", count: 0 },
    { name: "Mini Games", count: 0 },
  ]);
  const [giftWalletBalance, setGiftWalletBalance] = useState(
    profileData?.user?.gift_wallet
  );
  const [isSportGame, setIsSportGame] = useState(false);

  useEffect(() => {
    const handleGiftWallet = (user) => {
      if (user?.user?.gift_wallet) {
        setGiftWalletBalance(user?.user?.gift_wallet);
      }
    };

    eventEmitter.on("refreshUserData", handleGiftWallet);

    return () => {
      eventEmitter.removeListener("refreshUserData", handleGiftWallet);
    };
  }, []);

  const switchToSignup = () => {
    setLoginOpen(false);
    setSignupOpen(true);
  };

  const switchToLogin = () => {
    setSignupOpen(false);
    setLoginOpen(true);
  };

  useOutsideAlerter(wrapperRef, open, setOpen);

  useEffect(() => {
    window.addEventListener("unload", handleSignout);
    return () => {
      window.removeEventListener("unload", handleSignout);
    };
  }, []);

  useEffect(() => {
    // if (query == "") return;

    const timer = setTimeout(() => {
      // setGameSearch(query);
    }, 2000);

    return () => clearTimeout(timer);
  }, [query]);

  useEffect(() => {
    if (width <= 990) {
      setMenuOpen(!open);
    } else {
      setMenuOpen(open);
    }
  }, [open]);

  useEffect(() => {
    // const fromLogin = sessionStorage.getItem("fromLogin");

    // if (fromLogin == "true") {
    //   // ❗ Stop API calls on first load after redirect
    //   sessionStorage.removeItem("fromLogin");
    //   return;
    // }

    if (auth) {
      if (!profileData && !fromLogin) {
        // handleUserBalance();
        getProfileData();
      } else {
        // toggleTheme(
        //   profileData?.user?.color_mode ? profileData?.user?.color_mode : "Dark"
        // );
        setNotificationToggle(profileData?.user?.notification);
        setLang(profileData?.user?.language);
        i18n.changeLanguage(profileData?.user?.language);
      }
    }
  }, [profileData, auth]);
  useEffect(() => {
    console.log("first", category?.casino);
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme) {
      toggleTheme(savedTheme); // Use stored theme
    } else if (configData?.color_mode) {
      toggleTheme(configData?.color_mode); // Fallback to config if no saved theme
      localStorage.setItem("theme", configData?.color_mode);
    }

    if (configData) {
      setCategory((prev) => ({
        ...prev,
        casino: configData.casinoCategories
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name)),
        live: configData.liveCasinoCategory
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name)),
        sports: configData.sportsCategory,
      }));
    } else {
      const fetchGeneralConfig = async () => {
        try {
          const domain = process.env.REACT_APP_FRONT_URL;
          const payload = { domain };
          const response = await api.post("general-config", payload);
          const data = response.data?.data;

          if (data) {
            setCategory((prev) => ({
              ...prev,
              casino: data.casinoCategories
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name)),
              live: data.liveCasinoCategory
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name)),
              sports: data.sportsCategory,
            }));
          }
        } catch (error) {
          console.error("Failed to fetch General Config directly:", error);
        }
      };

      fetchGeneralConfig();
    }
  }, [configData, configData?.color_mode]);

  const handleDrawerOpen = (event) => {
    event.preventDefault();
    setOpen(!open);
    handleSidebarDrawerInit();
  };

  const handleSidebarClick = (e) => {
    navigate(`/${e.url}`);
    setCurrentPage(e.label);
  };

  const handleSignout = () => {
    setLogoutModal(true);
  };

  const getProfileData = () => {
    if (auth) {
      dispatch(getProfile())
        .unwrap()
        .then((res) => {
          handleConfig(res?.user?.parent_user_id);
          handleUserBalance();
        })
        .catch((error) => {
          console.error("Failed :", error);
        });
    }
  };

  const handleConfig = (id) => {
    const domain = process.env.REACT_APP_FRONT_URL;
    const payload = { domain: domain, parentId: id };

    console.log(315, payload, "config")
    dispatch(config(payload))
      .unwrap()
      .then((res) => {
        // configData will be updated in store, triggering the useEffect
      })
      .catch((error) => {
        toast.error(error?.message);
        console.error("Failed :", error);

      });
  };

  useEffect(() => {
    const handleOpenLogin = () => setLoginOpen(true);
    eventEmitter.on("openLogin", handleOpenLogin);
    return () => {
      eventEmitter.off("openLogin", handleOpenLogin);
    };
  }, []);

  useEffect(() => {
    if (auth && profileData?.user?.notification) {
      handleGetAllNotification();
    }
  }, [auth, profileData]);

  const handleGetAllNotification = () => {
    dispatch(getAllNotification())
      .unwrap()
      .then((res) => {
        setNotifications(res.notifications);
      })
      .catch((error) => {
        console.error("Failed :", error);
      });
  };

  const handleMarkSeen = (all, id) => {
    if (all) {
      dispatch(markSeenAll())
        .unwrap()
        .then((res) => { })
        .catch((error) => {
          console.error("Failed :", error);
        });
    } else {
      dispatch(markSeen({ _id: id }))
        .unwrap()
        .then((res) => { })
        .catch((error) => {
          console.error("Failed :", error);
        });
    }
  };

  function openNotification() {
    navigate("/notification");
    // document.getElementById("notificationPanel").classList.add("active");
  }

  function closeNotification() {
    // document.getElementById("notificationPanel").classList.remove("active");
  }

  useEffect(() => {
    getData();
    const handleClickOutside = (e) => {
      if (!e.target.closest(".app-navbar-item")) {
        setHoverProfile(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (fromLogin == true || fromLogin == "true") {
      setLoginOpen(true);
    }
    const params = new URLSearchParams(window.location.search);

    // "123"
    const ref = params.get("ref");

    if (ref == "dashboard") {
      setLoginOpen(true);
      const url = new URL(window.location.href);
      url.searchParams.delete("ref"); // remove just `userId`
      window.history.replaceState({}, document.title, url);
    } // "dashboard"
  }, [fromLogin]);

  const handleAllTabClick = (item, e) => {
    console.log("handleAllTabClick");
    e.preventDefault();
    document.getElementById("page-wrap")?.scrollIntoView({
      behavior: "smooth",
    });

    if (item?.label == "ALL") {
      setIsToggled((prevState) => {
        const newState = !prevState;

        if (newState) {
          document.body.classList.add("no-scroll");
        } else {
          document.body.classList.remove("no-scroll");
        }

        return newState;
      });

      handleDrawerOpen(e);
    } else if (item?.label == "CASINO") {
      document.body.classList.remove("no-scroll");
      navigate(`/casino-games/${"casino"}`, {
        state: { category: "", name: "non-live", sidebar_cat: "casino" },
      });
    } else if (item?.label == "LIVE CASINO") {
      document.body.classList.remove("no-scroll");
      navigate(`/casino-games/${"live"}`, {
        state: { category: "", name: "live", sidebar_cat: "live" },
      });
    } else if (item?.label == "GAMES") {
      document.body.classList.remove("no-scroll");
      navigate(`/${item?.link}`);
    } else if (item?.label == "SPORTS") {
      document.body.classList.remove("no-scroll");
      setSelectedGame(category.sports[0]);

      handleGameClick();
      // navigate("/game-launch", {
      //   state: {
      //     game_id: category?.sports[0]?.game_id,
      //     game: category?.sports[0],
      //   },
      // });
    } else if (item?.label == "LIVE") {
      document.body.classList.remove("no-scroll");
      navigate("/game-launch", {
        state: {
          game_id: category?.sports[0]?.game_id,
          game: category?.sports[0],
        },
      });
    } else if (item?.label == "LIVE") {
      document.body.classList.remove("no-scroll");
      navigate("/game-launch", {
        state: {
          game_id: category?.sports[0]?.game_id,
          game: category?.sports[0],
        },
      });
    } else if (item?.label == "BETSLIP") {
      document.body.classList.remove("no-scroll");
      navigate("/game-launch", {
        state: {
          game_id: category?.sports[0]?.game_id,
          game: category?.sports[0],
        },
      });
    } else if (item?.label == "MYBETS") {
      document.body.classList.remove("no-scroll");
      navigate("/game-launch", {
        state: {
          game_id: category?.sports[0]?.game_id,
          game: category?.sports[0],
        },
      });
    } else if (item?.label == "DRAFTS") {
      document.body.classList.remove("no-scroll");
      navigate("/game-launch", {
        state: {
          game_id: category?.sports[0]?.game_id,
          game: category?.sports[0],
        },
      });
    } else {
      setIsToggled(false);
      document.body.classList.remove("no-scroll");
    }
  };

  const [dotAnimated, setDotAnimated] = useState("");
  const [dotAnimatedNone, setDotAnimatedNone] = useState("");

  const closeRakebackModal = () => {
    setIsRakebackModalOpen(false);
  };

  const handleUserBalance = () => {
    dispatch(fetchUserBalance())
      .unwrap()
      .then((res) => {
        if (res?.success) {
          setBalance(res.balance);
          setGiftWalletBalance(res.wallet);
        }
      })
      .catch((error) => {
        toast.error(error.message);
        console.error("Failed :", error);
      });
  };

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector("#navbar-wrapper .navbar");
      if (window.scrollY > 20 && navbar) {
        navbar.classList.add("scrolled");
      } else if (navbar) {
        navbar.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAnim = (idName, name) => {
    const el = document.getElementById("sidebar-wrapper");
    if (el) {
      const isShown = el.classList.contains("custom-toggle");
      if (isShown) {
        el.classList.remove("custom-toggle");
        setSidebarToggled(false);
      }
    }
    const casinoEl = document.getElementById(idName);

    if (idName) {
      casinoEl.addEventListener("shown.bs.collapse", () => {
        setDotAnimated("");
        setTimeout(() => {
          setDotAnimated(name);
        }, 0);

        setDotAnimatedNone("");
      });

      casinoEl.addEventListener("hidden.bs.collapse", () => {
        setDotAnimatedNone(name);
      });
    } else {
      setDotAnimated(name);
    }
  };
  function setSidebarHeight() {
    const sidebar = document.querySelector(".sidebar.open");
    if (sidebar) {
      sidebar.style.height = `${window.innerHeight}px`;
    }
  }

  window.addEventListener("resize", setSidebarHeight);
  window.addEventListener("orientationchange", setSidebarHeight);
  document.addEventListener("DOMContentLoaded", setSidebarHeight);
  setSidebarHeight();

  const hideSidebarRoutes = ["/game-launch"];
  const gameId = location?.state?.game_id == "550000";
  const shouldHideSidebar =
    hideSidebarRoutes.includes(location.pathname) && gameId;
  const collapseIds = [
    "collapseCasino",
    "collapseliveCasino",
    "collapseSports",
  ];
  useEffect(() => {
    if (sidebarToggled && !isMobile && shouldHideSidebar) {
      document.body.classList.add("custom-toggle-applied");
    } else {
      document.body.classList.remove("custom-toggle-applied");
    }
  }, [sidebarToggled, shouldHideSidebar]);
  useEffect(() => {
    const el = document.getElementById("sidebar-wrapper");
    if (el && shouldHideSidebar && !isMobile) {
      if (shouldHideSidebar) {
        document.body.classList.add("custom-toggle-applied");
        el.classList.add("custom-toggle");
        setSidebarToggled(true);
        collapseIds.forEach((id) => {
          const collapseEl = document.getElementById(id);
          const triggerBtn = document.querySelector(
            `[data-bs-target="#${id}"]`
          );

          // If the element exists and is currently shown, collapse it
          if (collapseEl && collapseEl.classList.contains("show")) {
            collapseEl.classList.remove("show");
          }

          // Update the aria-expanded attribute on the trigger button for accessibility
          if (triggerBtn) {
            triggerBtn.setAttribute("aria-expanded", "false");
            triggerBtn.classList.add("collapsed");
          }
        });
      } else {
        document.body.classList.remove("custom-toggle-applied");
        el.classList.remove("custom-toggle");
      }
    }
  }, [location.state?.game_id, shouldHideSidebar]);

  useEffect(() => {
    if (profileData) {
      const interval = setInterval(handleUserBalance, 30000);

      return () => clearInterval(interval);
    }
  }, []);

  const toggleSidebar = () => {
    const el = document.getElementById("sidebar-wrapper");

    if (el) {
      const isShown = el.classList.contains("custom-toggle");
      if (isShown) {
        el.classList.remove("custom-toggle");
        setSidebarToggled(false);
      } else {
        collapseIds.forEach((id) => {
          const collapseEl = document.getElementById(id);
          const triggerBtn = document.querySelector(
            `[data-bs-target="#${id}"]`
          );

          // If the element exists and is currently shown, collapse it
          if (collapseEl && collapseEl.classList.contains("show")) {
            collapseEl.classList.remove("show");
          }

          // Update the aria-expanded attribute on the trigger button for accessibility
          if (triggerBtn) {
            triggerBtn.setAttribute("aria-expanded", "false");
            triggerBtn.classList.add("collapsed");
          }
        });
        el.classList.add("custom-toggle");
        setSidebarToggled(true);
      }
    }
  };

  useEffect(() => {
    if (query?.length >= 3) {
      if (selected == "all") {
        getData("");
      } else if (selected == "casino") {
        getData("non-live");
      } else if (selected == "live") {
        getData("live");
      }
    }
  }, [selected, query]);
  const getData = (cat) => {
    setIsLoading(true);
    dispatch(
      getDreamCasinoGames({
        page: 1,
        limit: 20,
        perpage: 20,
        search_by_category: cat,
        search_by_provider: "", //MAC88
        search_by_text: query || "",
        is_popular: 0,
        is_main_search: true,
        parent_user_id: profileData?.user?.parent_user_id,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.categoryCount) {
          const combined = res.categoryCount.reduce((acc, curr) => {
            const name = curr.name == "Instant/Casual" ? "Casino" : curr.name;
            acc[name] = (acc[name] || 0) + curr.count;
            return acc;
          }, {});

          const merged = categoryCount.map((def) => ({
            ...def,
            count: combined[def.name] || 0,
          }));

          setCategoryCount(merged);
        }

        if (res.data?.length == 0) {
          setGamesWithBg1([]);
        }
        setGamesWithBg1([]);
        const validatedGames = res?.data?.map((game) => ({
          ...game,
          isBroken: false, // flag for broken thumbnails
        }));
        validatedGames?.forEach((game, idx) => {
          const img = new Image();
          img.src = game?.url_thumb;

          img.onload = () => {
            setGamesWithBg1((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: false }; // ✅ valid image
              return copy;
            });
          };

          img.onerror = () => {
            setGamesWithBg1((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: true }; // ❌ broken → mark
              return copy;
            });
          };
        });
      })

      .catch((error) => {
        // toast.error(error.message);
        console.error("Failed :", error);
      })
      .finally(() => {
        setIsLoading(false); // ✅ stop loading
      });
  };
  const findCategoryCount = (category) => {
    return query.length >= 3
      ? categoryCount?.find((cat) => cat.name == category)?.count
      : 0;
  };

  const handleRefreshClick = async () => {
    setRefreshing(true);
    await handleUserBalance(); // your API call
    setTimeout(() => setRefreshing(false), 800); // stop after animation
  };

  useEffect(() => {
    if (location.state?.openLoginModal) {
      setLoginOpen(true);
      // Optionally clear the state so it doesn't reopen on refresh or back navigation
      window.history.replaceState({}, document.title);
    }
  }, [location.state, setLoginOpen]);
  const handlePlayModeSelect = (mode) => {
    if (!selectedGame) return;

    navigate("/game-launch", {
      state: {
        game_id: selectedGame.game_id,
        game: selectedGame,
        play_mode: mode,
      },
    });
  };

  return (
    <div>
      <div id="wrapper" className={`wrapper ${isToggled ? "toggled" : ""}`}>
        {/* <SubHumburgerMenu menuOpen={submenuOpen} setMenuOpen={setsubMenuOpen} /> */}
        {window.innerWidth > 1024 && (
          <aside
            id="sidebar-wrapper"
            className={`${shouldHideSidebar && !isMobile ? `custom-sidebar ` : ""
              }`}
            tabindex="-1"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div
              className={
                !sidebarToggled && shouldHideSidebar && !isMobile
                  ? "toggle-btn-opn btn btn-danger"
                  : "d-none"
              }
              onClick={() => toggleSidebar()}
            >
              <GoChevronLeft />
            </div>
            <div className="sidebar-brand mx-auto">
              <img
                src={sidebarToggled && shouldHideSidebar ?
                  (configData?.website_logo ? configData?.website_logo : LogoMobile) :
                  (configData?.website_logo ? configData?.website_logo : Logo)}
                alt=""
                className="cursor-pointer logo-image"
                onClick={() => {
                  navigate("/");
                }}
              />
            </div>
            <ul className="sidebar-nav p-0">
              {/* <hr /> */}
              <li className="cursor-pointer" onClick={handleGameClick}>
                <div className="accordion custom-accordian-drop my-2 centered-container">
                  <p className="accordion-header accordion-header-side d-flex justify-content-between centered-content">
                    <div className="fs-14 ps-1">
                      <span
                        className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                          }`}
                      >
                        <img
                          src={Cricket}
                          alt="icon"
                          width={23}
                          height={23}
                          className="svg-icon"
                        />
                      </span>
                      <span className="ms-1 me-2 fs-11 linear-wipe text-uppercase fw-bold">
                        Football
                      </span>
                    </div>
                    <div
                      className={
                        dotAnimated == "Cricket"
                          ? "sidebar-animate"
                          : "sidebar-animate-none"
                      }
                    >
                      <span
                        className={`dot-base dot-shadow1 ${dotAnimated !== "Cricket" ? "dot-positioned" : ""
                          }`}
                      ></span>
                    </div>
                  </p>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  handleAnim("collapseCasino", "Casino");
                  setDotAnimated("Casino");
                  // handleSidebarClick(item);
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-2 centered-container "
                  id="accordionExampleCasino"
                >
                  <div className="accordion-item bg-transparent">
                    <p
                      className="accordion-header accordion-header-side centered-content "
                      id="headingCasino"
                    >
                      <button
                        className="accordion-button py-0 fs-14 text-white d-flex justify-content-between
                       px-0 side-link-dropdown "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseCasino"
                        aria-expanded="true"
                        aria-controls="collapseCasino"
                      // {...(profileData?.user
                      //   ? {
                      //       "data-bs-toggle": "collapse",
                      //       "data-bs-target": "#collapseCasino",
                      //       "aria-expanded": "true",
                      //       "aria-controls": "collapseCasino",
                      //     }
                      //   // : {
                      //   //     onClick: () => setLoginOpen(true),
                      //   //   })}
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 centered-icons me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={casinoMain}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon sidebar-svg ms-1"
                            />
                          </span>
                          <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe linear-wipe">
                            Casino
                          </span>
                        </div>

                        <div
                          className={`${dotAnimated == "Casino"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            } `}
                        >
                          <span
                            className={`dot-base dot-shadow2 ${dotAnimated !== "Casino" ? "dot-positioned" : ""
                              }`}
                          ></span>
                        </div>
                      </button>
                    </p>
                    <div
                      id="collapseCasino"
                      className=" accordion-collapse collapse  bg-transparent" //show
                      aria-labelledby="headingCasino"
                      data-bs-parent="#accordionExampleCasino"
                    >
                      <hr />
                      <div className="custom-accordion-body fs-11 bg-transparent w-max-content ">
                        <div
                          className={`bg-transparent p-1  ${isToggled && "ms-0"
                            } `}
                        >
                          {/* configData?.casinoCategories? here */}

                          {category?.casino && category.casino.length > 0 ? (
                            category?.casino?.map((item, index) => {
                              // Fallback formatter: "cuda" → "Cuda"

                              return (
                                <div
                                  key={index}
                                  className={`d-flex align-items-center mt-1 cms-section cursor-pointer ${item.name == currentPage
                                    ? "active side-link"
                                    : ""
                                    } ${isToggled && "ps-0"}`}
                                  onClick={() => {
                                    // navigate(item.url);
                                    // if (!profileData) {
                                    document.body.classList.remove("no-scroll");
                                    navigate(`/casino-games/${item.name}`, {
                                      state: {
                                        category: item._id,
                                        name: item.name,
                                        sidebar_cat: "casino",
                                      },
                                    });

                                    setCurrentPage(item.name);
                                    // } else {
                                    //   setLoginOpen(!isLoginOpen);
                                    // }
                                  }}
                                >
                                  <span className="svg-icon svg-icon-2"></span>
                                  <span className="ms-3 fs-11 text-capitalize lh-lg">
                                    {item?.name}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <SkeletonTheme
                              baseColor="#2a2d3e"
                              highlightColor="#3e4259"
                            >
                              {[...Array(5)].map((_, i) => (
                                <div
                                  key={i}
                                  className="d-flex align-items-center mt-2 ps-2"
                                >
                                  {/* <Skeleton width={20} height={20} circle /> */}
                                  <div className="ms-3">
                                    <Skeleton width={100} height={15} />
                                  </div>
                                </div>
                              ))}
                            </SkeletonTheme>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  setDotAnimated("Live Casino");
                  handleAnim("collapseliveCasino", "Live Casino");
                  // handleSidebarClick(item);
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-2 centered-container "
                  id="accordionExampleCasino"
                >
                  <div className="accordion-item bg-transparent">
                    <p
                      className="accordion-header accordion-header-side centered-content "
                      id="headingliveCasino"
                    >
                      <button
                        className="accordion-button py-0 fs-14 text-white 
                       px-0 side-link-dropdown d-flex justify-content-between"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseliveCasino"
                        aria-expanded="true"
                        aria-controls="collapseliveCasino"
                      // {...(profileData?.user
                      //   ? {
                      //       "data-bs-toggle": "collapse",
                      //       "data-bs-target": "#collapseliveCasino",
                      //       "aria-expanded": "true",
                      //       "aria-controls": "collapseliveCasino",
                      //     }
                      //   : {
                      //       onClick: () => setLoginOpen(true),
                      //     })}
                      >
                        <div className="fs-11 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 centered-icons me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={liveCasinoMain}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon sidebar-svg-red ms-1"
                            />
                          </span>
                          <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                            Live Casino
                          </span>
                        </div>

                        <div
                          className={`${dotAnimated == "Live Casino"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            }`}
                        >
                          <span
                            className={`dot-base dot-shadow3 ${dotAnimated !== "Live Casino"
                              ? "dot-positioned"
                              : ""
                              }`}
                          />
                        </div>
                      </button>
                    </p>
                    <div
                      id="collapseliveCasino"
                      className=" accordion-collapse collapse  bg-transparent " // show
                      aria-labelledby="headingliveCasino"
                      data-bs-parent="#accordionExampleCasino"
                    >
                      <hr />
                      <div className="custom-accordion-body fs-11 w-max-content ">
                        <div
                          className={`bg-transparent p-1  ${isToggled && "ms-0"
                            } `}
                        >
                          {/* liveCasinoBarList here */}
                          {category.live && category.live.length > 0 ? (
                            category.live?.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className={`d-flex align-items-center mt-1 cms-section cursor-pointer ${item.name == currentPage
                                    ? "active side-link"
                                    : ""
                                    } ${isToggled && "ps-0"}`}
                                  onClick={() => {
                                    // navigate(item.url);
                                    // if (profileData) {
                                    navigate(
                                      `/live-casino-games/${item.name}`,
                                      {
                                        state: {
                                          category: item._id,
                                          name: item.name,
                                          sidebar_cat: "live",
                                        },
                                      }
                                    );
                                    setCurrentPage(item.name);
                                    // } else {
                                    //   setLoginOpen(!isLoginOpen);
                                    // }
                                  }}
                                >
                                  <span className="svg-icon svg-icon-2"></span>
                                  <span className="ms-3 fs-11 lh-lg text-capitalize">
                                    {item.name}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <SkeletonTheme
                              baseColor="#2a2d3e"
                              highlightColor="#3e4259"
                            >
                              {[...Array(5)].map((_, i) => (
                                <div
                                  key={i}
                                  className="d-flex align-items-center mt-2 ps-2"
                                >
                                  {/* <Skeleton width={20} height={20} circle /> */}
                                  <div className="ms-3">
                                    <Skeleton width={100} height={15} />
                                  </div>
                                </div>
                              ))}
                            </SkeletonTheme>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  // setDotAnimated("Sports");
                  handleAnim("collapseSports", "Sports");
                  // handleSidebarClick(item);
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-2 centered-container"
                  id="accordionExampleCasino"
                >
                  <div className="accordion-item bg-transparent ">
                    <p
                      className="accordion-header accordion-header-side centered-content "
                      id="headingSports"
                    >
                      <button
                        className="accordion-button py-0 fs-14 text-white 
                       px-0 side-link-dropdown d-flex justify-content-between"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSports"
                        aria-expanded="true"
                        aria-controls="collapseSports"
                      // {...(profileData?.user
                      //   ? {
                      //       "data-bs-toggle": "collapse",
                      //       "data-bs-target": "#collapseSports",
                      //       "aria-expanded": "true",
                      //       "aria-controls": "collapseSports",
                      //     }
                      //   : {
                      //       onClick: () => setLoginOpen(true),
                      //     })}
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 centered-icons me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={sportsMain}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon sidebar-svg ms-1"
                            />
                          </span>
                          <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                            Sports
                          </span>
                        </div>
                        <div
                          className={`${dotAnimated == "Sports"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            }`}
                        >
                          <span
                            className={`dot-base dot-shadow4 ${dotAnimated !== "Sports" ? "dot-positioned" : ""
                              }`}
                          />
                        </div>
                      </button>
                    </p>
                    <div
                      id="collapseSports"
                      className=" accordion-collapse collapse  bg-transparent " // show
                      aria-labelledby="headingSports"
                      data-bs-parent="#accordionExampleCasino"
                    >
                      <hr />
                      <div className="custom-accordion-body fs-11 w-max-content ">
                        <div
                          className={`bg-transparent p-1  ${isToggled && "ms-0"
                            } `}
                        >
                          {/* sportsBarList  */}
                          {category?.sports && category.sports.length > 0 ? (
                            category?.sports?.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className={`d-flex align-items-center mt-0 cms-section cursor-pointer ${item.name == currentPage
                                    ? "active side-link"
                                    : ""
                                    } ${isToggled && "ps-0"}`}
                                  onClick={() => {
                                    handleGameClick();
                                  }}
                                >
                                  <span className="svg-icon svg-icon-2">
                                    <img
                                      draggable="false"
                                      loading="lazy"
                                      src={item.img}
                                      alt=""
                                    />
                                    {/* {casinoIcons[index]?.img || null} */}
                                  </span>
                                  <span className="ms-0 fs-11 text-capitalize lh-lg">
                                    {/* {item.game_name} */}
                                    Sports
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <SkeletonTheme
                              baseColor="#2a2d3e"
                              highlightColor="#3e4259"
                            >
                              {[...Array(5)].map((_, i) => (
                                <div
                                  key={i}
                                  className="d-flex align-items-center mt-2 ps-2"
                                >
                                  {/* <Skeleton width={20} height={20} circle /> */}
                                  <div className="ms-3">
                                    <Skeleton width={100} height={15} />
                                  </div>
                                </div>
                              ))}
                            </SkeletonTheme>
                          )}
                        </div>
                      </div>
                      <hr />
                      {/* <div className="text-center">
                        <span className=" fs-11 fw-bold text-capitalize text-white text-center">
                          Top League
                        </span>
                        {[
                          { name: "Serie A", num: 10 },
                          { name: "NHL", num: 2 },
                          { name: "NBA", num: 2 },
                          { name: "ATP - US Open", num: 2 },
                          { name: "WTA - US Open", num: 2 },
                        ]?.map((itm, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between lh-lg"
                          >
                            <div className="">
                              <span
                                className={`svg-icon svg-icon-2 me-2 ${
                                  isToggled && "ms-2 me-3"
                                }`}
                              >
                                <img
                                  src={sportsMain}
                                  alt="icon"
                                  width={18}
                                  height={18}
                                  className="svg-icon "
                                />
                              </span>
                              <span className="ms-1 fs-11 text-capitalize lh-lg">
                                {itm.name}
                              </span>
                            </div>
                            <span className="ms-1 fs-11 ">{itm.num}</span>
                          </div>
                        ))}
                        <hr />
                        <div className="d-flex justify-content-center mt-3 text-center m-auto">
                          {[
                            { str: "ALL" },
                            { str: "6H" },
                            { str: "12H" },
                            { str: "24H" },
                            { str: "48H" },
                          ].map((itm, index) => (
                            <div
                              key={index}
                              className={"text-center m-auto cursor-pointer"}
                              onClick={() => {
                                setSelectHour(itm.str);
                              }}
                            >
                              <div className="m-auto d-flex justify-content-center">
                                <div
                                  className={`${
                                    selectHour == itm.str
                                      ? "circle-yellow"
                                      : "circle"
                                  } `}
                                ></div>
                              </div>

                              <span className="ms-1 fs-11 ">{itm.str}</span>
                            </div>
                          ))}
                        </div>
                        <hr />

                        <SportsFilter selectHour={selectHour} />
                      </div> */}
                    </div>
                  </div>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  // setDotAnimated("E Sports");
                  handleAnim("", "E Sports");
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-2  centered-container"
                  id="accordionExampleCasino"
                  onClick={() => {
                    document.body.classList.remove("no-scroll");
                    handleGameClick();
                  }}
                >
                  <p
                    className="accordion-header accordion-header-side d-flex justify-content-between centered-content"
                    id="headingliveCasino"
                  >
                    <div className="fs-14 ps-1">
                      <span
                        className={`svg-icon svg-icon-2 centered-icons me-2 ${isToggled && "ms-2 me-3"
                          }`}
                      >
                        <img
                          src={eSports}
                          alt="icon"
                          width={23}
                          height={23}
                          className="svg-icon sidebar-svg"
                        />
                      </span>
                      <span className="ms-1 text-uppercase fw-bold me-2 fs-11 linear-wipe">
                        E-Sports
                      </span>
                    </div>
                    <div
                      className={`${dotAnimated == "E Sports"
                        ? "sidebar-animate"
                        : "sidebar-animate-none"
                        }`}
                    >
                      <span
                        className={`dot-base dot-shadow5 ${dotAnimated !== "E Sports" ? "dot-positioned" : ""
                          }`}
                      />
                    </div>
                  </p>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  // setDotAnimated("Racing");
                  handleAnim("", "Racing");
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-2 centered-container"
                  id="accordionExampleCasino"
                  onClick={() => {
                    // if (profileData?.user) {
                    document.body.classList.remove("no-scroll");
                    navigate(`/casino-games/racing`, {
                      state: {
                        category: "racing",
                        name: "racing",
                        sidebar_cat: "racing",
                      },
                    });
                    // } else {
                    //   setLoginOpen(!isLoginOpen);
                    // }
                  }}
                >
                  <p
                    className="accordion-header accordion-header-side d-flex justify-content-between centered-content"
                    id="headingliveCasino"
                  >
                    <div className="fs-14 ps-1">
                      <span
                        className={`svg-icon svg-icon-2 centered-icons me-2 ${isToggled && "ms-2 me-3"
                          }`}
                      >
                        <img
                          src={Racing}
                          alt="icon"
                          width={23}
                          height={23}
                          className="svg-icon sidebar-svg"
                        />
                      </span>
                      <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                        Racing
                      </span>
                    </div>
                    <div
                      className={`${dotAnimated == "Racing"
                        ? "sidebar-animate"
                        : "sidebar-animate-none"
                        }`}
                    >
                      <span
                        className={`dot-base dot-shadow6 ${dotAnimated !== "Racing" ? "dot-positioned" : ""
                          }`}
                      />
                    </div>
                  </p>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  // setDotAnimated("Aviator");
                  handleAnim("", "Aviator");
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-2 centered-container"
                  id="accordionExampleCasino"
                  onClick={() => {
                    // if (profileData?.user) {
                    document.body.classList.remove("no-scroll");
                    navigate(`/casino-games/aviator`, {
                      state: {
                        category: "aviator",
                        name: "aviator",
                        sidebar_cat: "aviator",
                      },
                    });
                    // } else {
                    //   setLoginOpen(!isLoginOpen);
                    // }
                    // navigate(`/sportsbook/aviator`);
                  }}
                >
                  <p
                    className="accordion-header accordion-header-side d-flex justify-content-between centered-content"
                    id="headingliveCasino"
                  >
                    <div className="fs-14 ps-1">
                      <span
                        className={`svg-icon  svg-icon-2 centered-icons me-2 ${isToggled && "ms-2 me-3"
                          }`}
                      >
                        <img
                          src={Aviator}
                          alt="icon"
                          width={23}
                          height={23}
                          className="svg-icon sidebar-svg"
                        />
                      </span>
                      <span className="ms-1 text-uppercase fw-bold me-2 fs-11 linear-wipe">
                        Aviator
                      </span>
                    </div>

                    <div
                      className={`${dotAnimated == "Aviator"
                        ? "sidebar-animate"
                        : "sidebar-animate-none"
                        }`}
                    >
                      <span
                        className={`dot-base dot-shadow7 ${dotAnimated !== "Aviator" ? "dot-positioned" : ""
                          }`}
                      />
                    </div>
                  </p>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  handleAnim("", "Promotion");
                  // setDotAnimated("Promotion");
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-2 centered-container"
                  id="accordionExampleCasino"
                  onClick={() => {
                    document.body.classList.remove("no-scroll");
                    // if (profileData?.user) {
                    navigate("/promotion");
                    // } else {
                    //   setLoginOpen(!isLoginOpen);
                    // }
                  }}
                >
                  <p
                    className="accordion-header d-flex justify-content-between accordion-header-side centered-content "
                    id="headingliveCasino"
                  >
                    <div className="fs-14 ps-1">
                      <span
                        className={`svg-icon svg-icon-2 centered-icons me-2 ${isToggled && "ms-2 me-3"
                          }`}
                      >
                        <img
                          src={Promotions}
                          alt="icon"
                          width={23}
                          height={23}
                          className="svg-icon sidebar-svg"
                        />
                      </span>
                      <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                        Promotions
                      </span>
                    </div>
                    <div
                      className={`${dotAnimated == "Promotion"
                        ? "sidebar-animate"
                        : "sidebar-animate-none"
                        }`}
                    >
                      <span
                        className={`dot-base dot-shadow8 ${dotAnimated !== "Promotion" ? "dot-positioned" : ""
                          }`}
                      />
                    </div>
                  </p>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer mt-3 mb-2 custom-hide`
                }
              >
                <div
                  className="accordion  custom-accordian-drop my-2 me-3 "
                  id="accordionExampleCasino"
                  onClick={() => {
                    document.body.classList.remove("no-scroll");
                    // if (profileData?.user) {
                    navigate("/rakeback-vip-club");
                    // } else {
                    //   setLoginOpen(!isLoginOpen);
                    // }
                  }}
                >
                  <p
                    className="accordion-header-side position-relative "
                    id="headingliveCasino"
                  >
                    <img
                      draggable="false"
                      loading="lazy"
                      src={vipClub}
                      className="w-100"
                      alt=""
                    />

                    <span className="ms-1 me-2 vip-club-sidebar fw-bold text-uppercase img-text img-text-green">
                      RAKEBACK VIP CLUB
                    </span>
                  </p>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer custom-hide`
                }
              >
                <div
                  className="accordion  custom-accordian-drop my-2 me-3 "
                  id="accordionExampleCasino"
                  onClick={() => {
                    document.body.classList.remove("no-scroll");
                    // if (profileData?.user) {
                    navigate("/tournaments");
                    // } else {
                    //   setLoginOpen(!isLoginOpen);
                    // }
                  }}
                >
                  <p
                    className="accordion-header-side position-relative "
                    id="headingliveCasino"
                  >
                    <img
                      draggable="false"
                      loading="lazy"
                      src={tournaments}
                      className="w-100"
                      alt=""
                    />

                    <span className="ms-1 me-2 fs-11 fw-bold text-uppercase img-text">
                      TOURNAMENTS
                    </span>
                  </p>
                </div>
              </li>

              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer custom-hide`
                }
              >
                <div
                  className="accordion  custom-accordian-drop my-2 me-3 "
                  id="accordionExampleCasino"
                  onClick={() => {
                    document.body.classList.remove("no-scroll");
                    // if (profileData?.user) {
                    navigate("/ludo-tournaments");
                    // } else {
                    //   setLoginOpen(!isLoginOpen);
                    // }
                  }}
                >
                  <p
                    className="accordion-header-side position-relative "
                    id="headingliveCasino"
                  >
                    <img
                      draggable="false"
                      loading="lazy"
                      src={tournaments}
                      className="w-100"
                      alt=""
                    />

                    <span className="ms-1 me-2 fs-11 fw-bold text-uppercase img-text">
                      LUDO TOURNAMENTS
                    </span>
                  </p>
                </div>
              </li>

              <li className="custom-hide">
                <InstantGames
                  setIsPopupOpen={setIsPopupOpen}
                  setSelectedGame={setSelectedGame}
                />
              </li>
              {/* <li className="text-center rounded-1 p-1 mt-2 custom-hide bg-gradient-dark">
                <div className="">
                  <div className=" d-flex text-center justify-content-center bg-gray m-2 fs-11 text-white text-capitalize text-center rounded-2 bg-custom-dark">
                    Buy Crypto
                    <span className=" mx-2" onClick={() => {}}>
                      <GoArrowRight size={16} />
                    </span>
                  </div>
                  <img
                    loading="lazy"
                    src={coin}
                    className="p-1 m-auto text-center"
                    alt="coin"
                  />
                </div>
              </li> */}

              <li className="mb-5">
                <hr />
                <>
                  {bottomSideBarList.map((item, index) => (
                    <div
                      key={index}
                      className={
                        item.label == currentPage
                          ? `active side-link cursor-pointer`
                          : `` +
                          `cursor-pointer cms-section ps-0 d-flex gap-1 centered-icon-div`
                      }
                      onClick={() => {
                        handleSidebarClick(item);
                      }}
                    >
                      <span className="svg-icon svg-icon-2 sidebar-svg centered-container ">
                        {item.img}
                      </span>
                      <span className="mb-0 fs-11 text-uppercase fw-bold linear-wipe cursor-pointer">
                        {/* {t(`Sidebar.${item.name}`)} */}
                        {item?.label}
                      </span>
                    </div>
                  ))}
                </>
              </li>
            </ul>
          </aside>
        )}

        {window.innerWidth <= 1024 && (
          <div className="sidebar-layout">
            <div className={`sidebar ${isToggled ? "open px-3" : ""}`}>
              {isToggled && (
                <div className="humburger-mobile-icon">
                  <div
                    className="sidebar-overlay"
                    onClick={() => {
                      setIsToggled(!isToggled);
                      document.body.classList.remove("no-scroll");
                    }}
                  >
                    <div className={`hamburger1 open`}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              )}
              <div className="sidebar-content">
                <div className="sidebar-brand mx-auto">
                  {window.innerWidth > 1024 && (
                    <img
                      src={Logo}
                      alt=""
                      className="cursor-pointer w-55"
                      onClick={() => {
                        navigate("/");
                      }}
                    />
                  )}
                </div>
                <ul className="sidebar-nav px-1 px-sm-1 px-md-0 px-lg-0 px-xl-0 py-0">
                  {/* <hr /> */}
                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setDotAnimated("Cricket");

                      // handleSidebarClick(item);
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 "
                      id="accordionExampleCasino"
                      onClick={() => {
                        document.getElementById("page-wrap")?.scrollIntoView({
                          behavior: "smooth",
                        });
                        document.body.classList.remove("no-scroll");
                        handleGameClick();

                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                        window.scrollTo({ top: 10, behavior: "smooth" });
                      }}
                    >
                      <p
                        className="accordion-header accordion-header-side d-flex justify-content-between"
                        id="headingliveCasino"
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={Cricket}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon"
                            />
                          </span>
                          <span className="ms-1 me-2 fs-11 linear-wipe text-uppercase fw-bold">
                            Football
                          </span>
                        </div>
                        <div
                          className={`${dotAnimated == "Cricket"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            }`}
                        ></div>
                      </p>
                    </div>
                  </li>
                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setDotAnimated("Casino");
                      // handleSidebarClick(item);
                      document.getElementById("page-wrap")?.scrollIntoView({
                        behavior: "smooth",
                      });
                      document.body.classList.remove("no-scroll");
                      // if (!profileData?.user) {
                      //   setIsToggled(!isToggled);
                      // }
                      document.body.style.overflow = "auto";
                      window.scrollTo({ top: 10, behavior: "smooth" });
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 "
                      id="accordionExampleCasino"
                    >
                      <div className="accordion-item bg-transparent">
                        <p
                          className="accordion-header accordion-header-side "
                          id="headingCasino"
                        >
                          <button
                            className="accordion-button py-0 fs-14 text-white d-flex justify-content-between
                       px-0 side-link-dropdown"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseCasino"
                            aria-expanded="true"
                            aria-controls="collapseCasino"
                          // {...(profileData?.user
                          //   ? {
                          //       "data-bs-toggle": "collapse",
                          //       "data-bs-target": "#collapseCasino",
                          //       "aria-expanded": "true",
                          //       "aria-controls": "collapseCasino",
                          //     }
                          //   : {
                          //       onClick: () => setLoginOpen(true),
                          //     })}
                          // data-bs-toggle="collapse"
                          // data-bs-target="#collapseCasino"
                          // aria-expanded="true"
                          // aria-controls="collapseCasino"
                          >
                            <div className="fs-14 ps-1">
                              <span
                                className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                                  }`}
                              >
                                <img
                                  src={casinoMain}
                                  alt="icon"
                                  width={23}
                                  height={23}
                                  className="svg-icon sidebar-svg ms-1"
                                />
                              </span>
                              <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe linear-wipe">
                                Casino
                              </span>
                            </div>
                            <div
                              className={`${dotAnimated == "Casino"
                                ? "sidebar-animate"
                                : "sidebar-animate-none"
                                }`}
                            >
                              <span
                                className={`dot-base dot-shadow2 ${dotAnimated !== "Casino"
                                  ? "dot-positioned"
                                  : ""
                                  }`}
                              ></span>
                            </div>
                          </button>
                        </p>
                        <div
                          id="collapseCasino"
                          className=" accordion-collapse collapse  bg-transparent " //show
                          aria-labelledby="headingCasino"
                          data-bs-parent="#accordionExampleCasino"
                        >
                          <hr />
                          <div className="custom-accordion-body fs-11 w-max-content">
                            <div
                              className={`bg-transparent p-1  ${isToggled && "ms-0"
                                } `}
                            >
                              {/* configData?.casinoCategories? here casinoCategoriesList */}
                              {category?.casino?.map((item, index) => {
                                // Fallback formatter: "cuda" → "Cuda"

                                return (
                                  <div
                                    key={index}
                                    className={`d-flex align-items-center mt-1 cms-section cursor-pointer ${item.name == currentPage
                                      ? "active side-link"
                                      : ""
                                      } ${isToggled && "ps-0"}`}
                                    onClick={() => {
                                      // navigate(item.url);
                                      // if (profileData) {
                                      document.body.classList.remove(
                                        "no-scroll"
                                      );
                                      navigate(`/casino-games/${item.name}`, {
                                        state: {
                                          category: item._id,
                                          name: item.name,
                                          sidebar_cat: "casino",
                                        },
                                      });

                                      setCurrentPage(item.name);
                                      setIsToggled(!isToggled);
                                      document.body.style.overflow = "auto";
                                      // } else {
                                      //   document.body.classList.remove(
                                      //     "no-scroll"
                                      //   );
                                      //   setIsToggled(!isToggled);
                                      //   setLoginOpen(!isLoginOpen);
                                      // }
                                    }}
                                  >
                                    <span className="svg-icosidebar open px-3n svg-icon-2"></span>
                                    <span className="ms-3 fs-11 text-capitalize lh-lg">
                                      {item?.name}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setDotAnimated("Live Casino");
                      // handleSidebarClick(item);
                      document.getElementById("page-wrap")?.scrollIntoView({
                        behavior: "smooth",
                      });
                      document.body.classList.remove("no-scroll");
                      // if (!profileData?.user) {
                      //   setIsToggled(!isToggled);
                      // }
                      document.body.style.overflow = "auto";
                      window.scrollTo({ top: 10, behavior: "smooth" });
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 "
                      id="accordionExampleCasino"
                    >
                      <div className="accordion-item bg-transparent">
                        <p
                          className="accordion-header accordion-header-side "
                          id="headingliveCasino"
                        >
                          <button
                            className="accordion-button py-0 fs-14 text-white 
                       px-0 side-link-dropdown d-flex justify-content-between"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseliveCasino"
                            aria-expanded="true"
                            aria-controls="collapseliveCasino"
                          // {...(profileData?.user
                          //   ? {
                          //       "data-bs-toggle": "collapse",
                          //       "data-bs-target": "#collapseliveCasino",
                          //       "aria-expanded": "true",
                          //       "aria-controls": "collapseliveCasino",
                          //     }
                          //   : {
                          //       onClick: () => setLoginOpen(true),
                          //     })}
                          >
                            <div className="fs-11 ps-1">
                              <span
                                className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                                  }`}
                              >
                                <img
                                  src={liveCasinoMain}
                                  alt="icon"
                                  width={23}
                                  height={23}
                                  className="svg-icon sidebar-svg-red ms-1"
                                />
                              </span>
                              <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                                Live Casino
                              </span>
                            </div>

                            <div
                              className={`${dotAnimated == "Live Casino"
                                ? "sidebar-animate"
                                : "sidebar-animate-none"
                                }`}
                            >
                              <span
                                className={`dot-base dot-shadow2 ${dotAnimated !== "Live Casino"
                                  ? "dot-positioned"
                                  : ""
                                  }`}
                              ></span>
                            </div>
                          </button>
                        </p>
                        <div
                          id="collapseliveCasino"
                          className=" accordion-collapse collapse  bg-transparent " // show
                          aria-labelledby="headingliveCasino"
                          data-bs-parent="#accordionExampleCasino"
                        >
                          <hr />
                          <div className="custom-accordion-body fs-11 bg-transparent w-max-content ">
                            <div
                              className={`bg-transparent p-1  ${isToggled && "ms-0"
                                } `}
                            >
                              {/* liveCasinoBarList here */}
                              {category?.live?.map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={`d-flex align-items-center mt-1 cms-section cursor-pointer ${item.name == currentPage
                                      ? "active side-link"
                                      : ""
                                      } ${isToggled && "ps-0"}`}
                                    onClick={() => {
                                      // navigate(item.url);
                                      // if (profileData) {
                                      navigate(
                                        `/live-casino-games/${item.name}`,
                                        {
                                          state: {
                                            category: item._id,
                                            name: item.name,
                                            sidebar_cat: "live",
                                          },
                                        }
                                      );
                                      setCurrentPage(item.name);
                                      setIsToggled(!isToggled);
                                      document.body.style.overflow = "auto";
                                      // } else {
                                      //   setLoginOpen(!isLoginOpen);
                                      //   document.body.classList.remove(
                                      //     "no-scroll"
                                      //   );
                                      //   setIsToggled(!isToggled);
                                      // }
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-2"></span>
                                    <span className="ms-3 fs-11 lh-lg text-capitalize">
                                      {item.name}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setsubMenuOpen(!submenuOpen);
                      setDotAnimated("Sports");
                      // handleSidebarClick(item);
                      document.getElementById("page-wrap")?.scrollIntoView({
                        behavior: "smooth",
                      });
                      document.body.classList.remove("no-scroll");
                      // if (!profileData?.user) {
                      //   setIsToggled(!isToggled);
                      // }
                      document.body.style.overflow = "auto";
                      window.scrollTo({ top: 10, behavior: "smooth" });
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 "
                      id="accordionExampleCasino"
                    >
                      <div className="accordion-item bg-transparent ">
                        <p
                          className="accordion-header accordion-header-side "
                          id="headingSports"
                        >
                          <button
                            className="accordion-button py-0 fs-14 text-white 
                       px-0 side-link-dropdown d-flex justify-content-between"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseSports"
                            aria-expanded="true"
                            aria-controls="collapseSports"
                          // {...(profileData?.user
                          //   ? {
                          //       "data-bs-toggle": "collapse",
                          //       "data-bs-target": "#collapseSports",
                          //       "aria-expanded": "true",
                          //       "aria-controls": "collapseSports",
                          //     }
                          //   : {
                          //       onClick: () => setLoginOpen(true),
                          //     })}
                          >
                            <div className="fs-14 ps-1">
                              <span
                                className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                                  }`}
                              >
                                <img
                                  src={sportsMain}
                                  alt="icon"
                                  width={23}
                                  height={23}
                                  className="svg-icon sidebar-svg ms-1"
                                />
                              </span>
                              <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                                Sports
                              </span>
                            </div>
                            <div
                              className={`${dotAnimated == "Sports"
                                ? "sidebar-animate"
                                : "sidebar-animate-none"
                                }`}
                            >
                              <span
                                className={`dot-base dot-shadow2 ${dotAnimated !== "Sports"
                                  ? "dot-positioned"
                                  : ""
                                  }`}
                              ></span>
                            </div>
                          </button>
                        </p>
                        <div
                          id="collapseSports"
                          className=" accordion-collapse collapse  bg-transparent " // show
                          aria-labelledby="headingSports"
                          data-bs-parent="#accordionExampleCasino"
                        >
                          <hr />
                          <div className="custom-accordion-body d-flex flex-wrap fs-11 bg-transparent ">
                            <div
                              className={`bg-transparent d-flex flex-wrap p-1  ${isToggled && "ms-0"
                                } `}
                            >
                              {/* sportsBarList here */}
                              {category?.sports?.map((item, index) => (
                                <div
                                  key={index}
                                  className={`accordion-header-new px-2 my-1 d-flex align-items-center mt-0 cms-section cursor-pointer ${item.name == currentPage
                                    ? "active side-link"
                                    : ""
                                    } ${isToggled && "ps-0"}`}
                                  onClick={() => {
                                    if (profileData) {
                                      setCurrentPage(item.name);
                                      handleGameClick();
                                    } else {
                                      setLoginOpen(!isLoginOpen);
                                    }
                                    document.body.classList.remove("no-scroll");
                                    setIsToggled(!isToggled);

                                    document.body.style.overflow = "auto";
                                  }}
                                >
                                  <span className="svg-icon svg-icon-2">
                                    <img
                                      draggable="false"
                                      loading="lazy"
                                      src={item.img}
                                      alt=""
                                    />
                                  </span>
                                  <span className=" ms-0 fs-11 text-uppercase lh-lg">
                                    {/* {item.game_name} */}
                                    Sports
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                          <hr />
                          {/* <div className="text-center">
                            <span className=" fs-11 fw-bold text-capitalize text-white text-center">
                              Top League
                            </span>
                            {[
                              { name: "Serie A", num: 10 },
                              { name: "NHL", num: 2 },
                              { name: "NBA", num: 2 },
                              { name: "ATP - US Open", num: 2 },
                              { name: "WTA - US Open", num: 2 },
                            ]?.map((itm, index) => (
                              <div
                                key={index}
                                className="d-flex justify-content-between lh-lg"
                              >
                                <div className="">
                                  <span
                                    className={`svg-icon svg-icon-2 me-2 ${
                                      isToggled && "ms-2 me-3"
                                    }`}
                                  >
                                    <img
                                      src={sportsMain}
                                      alt="icon"
                                      width={18}
                                      height={18}
                                      className="svg-icon "
                                    />
                                  </span>
                                  <span className="ms-1 fs-11 text-capitalize lh-lg">
                                    {itm.name}
                                  </span>
                                </div>
                                <span className="ms-1 fs-11 ">{itm.num}</span>
                              </div>
                            ))}
                            <hr />
                            <div className="d-flex justify-content-center my-1 text-center m-auto">
                              {[
                                { str: "ALL" },
                                { str: "6H" },
                                { str: "12H" },
                                { str: "24H" },
                                { str: "48H" },
                              ].map((itm, index) => (
                                <div
                                  key={index}
                                  className={
                                    "text-center hour-div active m-auto cursor-pointer"
                                  }
                                  onClick={() => {
                                    setSelectHour(itm.str);
                                  }}
                                >
                                  <div className="m-auto d-flex justify-content-center">
                                    <div
                                      className={`${
                                        selectHour == itm.str
                                          ? "circle-yellow d-flex"
                                          : "circle d-flex"
                                      } `}
                                    ></div>
                                  </div>

                                  <span className="ms-1 fs-11 ">{itm.str}</span>
                                </div>
                              ))}
                            </div>

                            <SportsFilter selectHour={selectHour} />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setDotAnimated("E Sports");
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2  "
                      id="accordionExampleCasino"
                      onClick={() => {
                        document.body.classList.remove("no-scroll");
                        handleGameClick();

                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                      }}
                    >
                      <p
                        className="accordion-header accordion-header-side d-flex justify-content-between"
                        id="headingliveCasino"
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={eSports}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon sidebar-svg ms-0"
                            />
                          </span>
                          <span className="ms-0 text-uppercase fw-bold me-2 fs-11 linear-wipe">
                            E-Sports
                          </span>
                        </div>
                        <div
                          className={`${dotAnimated == "E Sports"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            }`}
                        ></div>
                      </p>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setDotAnimated("Racing");
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 "
                      id="accordionExampleCasino"
                      onClick={() => {
                        // if (profileData?.user) {
                        document.body.classList.remove("no-scroll");
                        navigate(`/casino-games/racing`, {
                          state: {
                            category: "racing",
                            name: "racing",
                            sidebar_cat: "racing",
                          },
                        });
                        // } else {
                        //   setLoginOpen(!isLoginOpen);
                        // }
                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                      }}
                    >
                      <p
                        className="accordion-header accordion-header-side d-flex justify-content-between"
                        id="headingliveCasino"
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={Racing}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon sidebar-svg"
                            />
                          </span>
                          <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                            Racing
                          </span>
                        </div>
                        <div
                          className={`${dotAnimated == "Racing"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            }`}
                        ></div>
                      </p>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setDotAnimated("Aviator");
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 "
                      id="accordionExampleCasino"
                      onClick={() => {
                        // if (profileData?.user) {
                        // navigate(`/sportsbook/aviator`);
                        document.body.classList.remove("no-scroll");
                        navigate(`/casino-games/aviator`, {
                          state: {
                            category: "aviator",
                            name: "aviator",
                            sidebar_cat: "aviator",
                          },
                        });
                        // } else {
                        //   setLoginOpen(!isLoginOpen);
                        // }
                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                      }}
                    >
                      <p
                        className="accordion-header accordion-header-side d-flex justify-content-between"
                        id="headingliveCasino"
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon  svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={Aviator}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon sidebar-svg"
                            />
                          </span>
                          <span className="ms-1 text-uppercase fw-bold me-2 fs-11 linear-wipe">
                            Aviator
                          </span>
                        </div>

                        <div
                          className={`${dotAnimated == "Aviator"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            }`}
                        ></div>
                      </p>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      setDotAnimated("Promotion");
                    }}
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 "
                      id="accordionExampleCasino"
                      onClick={() => {
                        document.body.classList.remove("no-scroll");
                        // if (profileData?.user) {
                        navigate("/promotion", {
                          state: {
                            setIsWalletOpen: true,
                            setLoginOpen: "Promotion from sidebar",
                          },
                        });
                        // } else {
                        //   setLoginOpen(!isLoginOpen);
                        // }
                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                      }}
                    >
                      <p
                        className="accordion-header d-flex justify-content-between accordion-header-side "
                        id="headingliveCasino"
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 me-2 ${isToggled && "ms-2 me-3"
                              }`}
                          >
                            <img
                              src={Promotions}
                              alt="icon"
                              width={23}
                              height={23}
                              className="svg-icon sidebar-svg"
                            />
                          </span>
                          <span className="ms-1 me-2 text-uppercase fw-bold fs-11 linear-wipe">
                            Promotions
                          </span>
                        </div>
                        <div
                          className={`${dotAnimated == "Promotion"
                            ? "sidebar-animate"
                            : "sidebar-animate-none"
                            }`}
                        ></div>
                      </p>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer mt-3 mb-2`
                    }
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 me-3 "
                      id="accordionExampleCasino"
                      onClick={() => {
                        document.body.classList.remove("no-scroll");
                        // if (profileData?.user) {
                        navigate("/rakeback-vip-club");
                        // } else {
                        //   setLoginOpen(!isLoginOpen);
                        // }
                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                      }}
                      style={{
                        backgroundImage: `url(${vipClub})`,
                        backgroundSize: "100% 100%",
                        height: "60px",
                        width: "100%",
                      }}
                    >
                      <p
                        className="accordion-header-side position-relative "
                        id="headingliveCasino"
                      >
                        {/* <img  draggable="false"  loading="lazy" src={vipClub} className="w-100" /> */}

                        <span
                          className="ms-1 me-2 vip-club-sidebar fw-bold text-uppercase img-text img-text-green"
                          style={{ transform: "translateY(5%)" }}
                        >
                          RAKEBACK VIP CLUB
                        </span>
                      </p>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer`
                    }
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 me-3 "
                      id="accordionExampleCasino"
                      onClick={() => {
                        document.body.classList.remove("no-scroll");
                        // if (profileData?.user) {
                        navigate("/tournaments");
                        window.scrollTo({ top: 10, behavior: "smooth" });
                        // } else {
                        //   setLoginOpen(!isLoginOpen);
                        // }
                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                      }}
                      style={{
                        backgroundImage: `url(${tournaments})`,
                        backgroundSize: "100% 100%",
                        height: "60px",
                        width: "100%",
                      }}
                    >
                      <p
                        className="accordion-header-side position-relative "
                        id="headingliveCasino"
                      >
                        <span
                          className="ms-1 me-2 vip-club-sidebar fw-bold text-uppercase img-text text-white"
                          style={{ transform: "translateY(5%)" }}
                        >
                          TOURNAMENTS
                        </span>
                      </p>
                    </div>
                  </li>

                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer`
                    }
                  >
                    <div
                      className="accordion  custom-accordian-drop my-2 me-3 "
                      id="accordionExampleCasino"
                      onClick={() => {
                        document.body.classList.remove("no-scroll");
                        // if (profileData?.user) {
                        navigate("/ludo-tournaments");
                        window.scrollTo({ top: 10, behavior: "smooth" });
                        // } else {
                        //   setLoginOpen(!isLoginOpen);
                        // }
                        setIsToggled(!isToggled);
                        document.body.style.overflow = "auto";
                      }}
                      style={{
                        backgroundImage: `url(${tournaments})`,
                        backgroundSize: "100% 100%",
                        height: "60px",
                        width: "100%",
                      }}
                    >
                      <p
                        className="accordion-header-side position-relative "
                        id="headingliveCasino"
                      >
                        <span
                          className="ms-1 me-2 vip-club-sidebar fw-bold text-uppercase img-text text-white"
                          style={{ transform: "translateY(5%)" }}
                        >
                          LUDO TOURNAMENTS
                        </span>
                      </p>
                    </div>
                  </li>

                  {!isToggled && <hr className="mt-3" />}
                  <li>
                    <InstantGames
                      setIsPopupOpen={setIsPopupOpen}
                      setSelectedGame={setSelectedGame}
                      isToggled={isToggled}
                      setIsToggled={setIsToggled}
                    />
                  </li>
                  {/* 
                  <li className="text-center rounded-1 p-1 mt-2 bg-gradient-dark">
                    <div className="">
                      <div className=" d-flex text-center justify-content-center bg-gray m-2 fs-12 text-white text-capitalize text-center rounded-2 bg-custom-dark">
                        Buy Crypto
                        <span className=" mx-2" onClick={() => {}}>
                          <GoArrowRight size={16} />
                        </span>
                      </div>
                      <img
                        loading="lazy"
                        src={coin}
                        alt=""
                        className="p-1 m-auto text-center"
                      />
                    </div>
                  </li> */}

                  <li
                    className=""
                    style={{
                      marginBottom: window.innerWidth > 1024 ? "20px" : "40px",
                    }}
                  >
                    <hr />
                    <>
                      {bottomSideBarList.map((item, index) => (
                        <div
                          key={index}
                          className={
                            item.label == currentPage
                              ? `active side-link`
                              : `` +
                              `cursor-pointer cms-section ps-0 d-flex gap-1`
                          }
                          onClick={() => {
                            handleSidebarClick(item);
                            setIsToggled(!isToggled);
                            document.body.style.overflow = "auto";
                            setDotAnimated(item?.label);
                          }}
                        >
                          <span className="svg-icon svg-icon-2 sidebar-svg ">
                            {item.img}
                          </span>
                          <span className="mb-0 fs-11 text-uppercase fw-bold linear-wipe cursor-pointer">
                            {/* {t(`Sidebar.${item.name}`)} */}
                            {item?.label}
                          </span>
                          <div
                            className={`${dotAnimated == item?.label
                              ? "sidebar-animate"
                              : "sidebar-animate-none"
                              }`}
                          >
                            <span
                              className=""
                              style={{
                                display: "block",
                                height: "15px",
                                width: "15px",
                                background:
                                  "radial-gradient(circle at center, rgba(120, 128, 128, 0.9), rgba(0, 128, 128, 0.4))",
                                borderRadius: "50%",
                                boxShadow:
                                  "0 0 20px 10px rgba(120, 128, 128, 0.6), 0 0 40px 20px rgba(0, 128, 128, 0.4)",

                                marginTop: "10px",
                                opacity: `${dotAnimated == item.label ? "0" : "0"
                                  }`,
                              }}
                            ></span>
                          </div>
                        </div>
                      ))}
                    </>
                  </li>
                </ul>
              </div>
            </div>

            {isToggled && (
              <div className="backdrop" onClick={() => setIsToggled(false)} />
            )}
          </div>
        )}

        <div id="navbar-wrapper">
          {/* {window.innerWidth >= 768 && ( */}

          {/* )} */}
          <div
            className={
              sidebarToggled && shouldHideSidebar && !isMobile
                ? "toggle-btn btn btn-danger"
                : "d-none"
            }
            onClick={() => toggleSidebar()}
          >
            <GoChevronRight />
          </div>
          <nav
            className="navbar navbar-inverse mt-1"
            id="navbarid"
            style={{ zIndex: "99999999999999 !important" }}
          >
            {window.innerWidth < 1024 ? (
              <>
                <div
                  className={`${!expand
                    ? "d-flex flex-column px-0 pt-1 gap-3"
                    : "d-flex w-100 px-2 pt-1"
                    }`}
                >
                  {/* Profile + Theme Switch */}
                  {!expand && (
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {profileData ? (
                        <img
                          src={LogoMobile}
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => {
                            navigate("/");
                          }}
                          style={{ width: "11%", maxWidth: "200px" }}
                        />
                      ) : (
                        <img
                          src={Logo}
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => {
                            navigate("/");
                          }}
                          style={{ width: "25%", maxWidth: "200px" }}
                        />
                      )}

                      <div className="d-flex justify-content-between align-items-center">
                        {profileData?.user && (
                          <div className="btn my-account py-1 justify-content-between px-1 gap-5 my-account-new custom-search-new">
                            <div className="d-flex align-items-center gap-2">
                              <IoMdRefresh
                                size={24}
                                className={`text-light cursor-pointer ${refreshing ? "animate-spin" : ""
                                  }`}
                                onClick={handleRefreshClick}
                              />
                              <span className="username ">
                                {new Intl.NumberFormat("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(
                                  balance ||
                                  profileData?.user?.usable_coin_balance ||
                                  0
                                )}
                              </span>
                            </div>
                            <img
                              src={INR}
                              width={18}
                              height={18}
                              alt=""
                              className="svg-icon svg-icon-2 text-center me-1"
                            />
                          </div>
                        )}
                      </div>
                      {/* Search */}
                      <div
                        className="search-container justify-content-center search-container-mobile"
                        style={{
                          minWidth: "0",
                          height: "2.2rem",
                          width: "11.5%",
                        }}
                      >
                        <img
                          src={Search}
                          width={15}
                          alt="search-icon"
                          className="svg-icon cursor-pointer"
                          onClick={() => setExpand(true)}
                        />
                      </div>

                      {profileData ? (
                        <div className="app-navbar-item ms-md-2 align-self-center">
                          <div
                            className="cursor-pointer symbol symbol-30px symbol-md-40px"
                            onClick={() => {
                              setHoverProfile((prev) => !prev); // toggle on click
                              setHoverTheme(false);
                            }}
                          >
                            <div className="btn my-account-mobile cursor-pointer px-2">
                              <div className="icon">
                                <img
                                  src={UserProfileIcon}
                                  alt="my account"
                                // style={{ borderRadius: "50%" }}
                                />
                              </div>
                            </div>
                          </div>

                          {hoverProfile && (
                            <div
                              className="menu menu-sub menu-sub-dropdown menu-gray-800 py-3 pb-2 mt-3 fs-6"
                              onClick={(e) => {
                                e.nativeEvent.stopImmediatePropagation();
                              }}
                              style={{ zIndex: 999 }}
                            >
                              {sideBarListNew.map((item, idx) => (
                                <div key={idx} className="mb-2 cursor-pointer">
                                  {/* <div className="separator my-1"></div> */}

                                  <div
                                    className={`menu-item px-2 py-1 mx-2 d-flex ${item.label == currentPage
                                      ? "active side-link"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      if (
                                        item.name == "deposit" ||
                                        item.name == "withdraw" ||
                                        item.name == "buy-crypto"
                                      ) {
                                        setIsWalletOpen(true);
                                      } else if (item.name == "rakeback") {
                                        setIsRakebackModalOpen(true);
                                      } else if (item.name == "logout") {
                                        setLogoutModal(true);
                                      } else {
                                        handleSidebarClick(item);
                                      }

                                      setHoverProfile((prev) => !prev);
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-2  ">
                                      {item.img}
                                    </span>
                                    <span className="menu-link fs-14 px-2">
                                      {item?.label}
                                    </span>
                                  </div>
                                </div>
                              ))}

                              {/* <div className="separator my-1"></div> */}

                              <hr />
                              <div
                                className="menu-item-logout px-2 py-1 mx-2 d-flex"
                                onClick={() => {
                                  handleSignout();
                                }}
                              >
                                <span className="svg-icon svg-icon-2  ">
                                  <img
                                    src={Logout}
                                    alt="icon"
                                    width={23}
                                    height={23}
                                    className="svg-icon"
                                  />
                                </span>
                                <span className="menu-link fs-14 px-2">
                                  Logout
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                            <span
                              className="text-white-btn fs-11  login-btn align-self-center cursor-pointer "
                              style={{
                                border: "1px solid white",
                                borderRadius: "20px",
                              }}
                              onClick={() => {
                                setLoginOpen(true);
                              }}
                            >
                              {t("SignUpPage.login")}
                            </span>
                          </div>
                          <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                            <span
                              className="box-green text-white-btn  fs-11 register-btn align-self-center cursor-pointer"
                              onClick={() => {
                                setSignupOpen(true);
                              }}
                            >
                              {t("SignUpPage.signUp")}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}

                  {(query || expand) && (
                    <form
                      autoComplete="off"
                      className={`${query || expand ? "w-100" : ""}`}
                    >
                      <div
                        className={`search-container  px-2 ${query || expand
                          ? "transition-[width] duration-500 ease-in-out"
                          : "width-205"
                          }`}
                        style={{
                          transition: "width 0.5s ease-in-out",
                          ...((query || expand) && {
                            minWidth: "unset",
                            maxWidth: "unset",
                          }),
                        }}
                      >
                        <img
                          src={Search}
                          width={15}
                          alt="search-icon"
                          className="svg-icon cursor-pointer ms-2"
                        />
                        <input
                          type="text"
                          // autoComplete="new-password"
                          name="disable-autofill"
                          className={`ps-3 custom-search-bar`}
                          value={query}
                          autoComplete="off"
                          placeholder="Search requires at least 3 characters"
                          onChange={(e) => {
                            const input = e.target.value;

                            setQuery(input);
                            setSelected("all");

                            const temp = input.toLowerCase().trim();
                            if (input.length >= 3) {
                              let result =
                                configData?.casinoProviders?.filter((item) =>
                                  (item?.name ?? "")
                                    .toLowerCase()
                                    .trim()
                                    .includes(temp)
                                ) || [];

                              // remove duplicates by id
                              result = result.filter(
                                (item, index, self) =>
                                  index ===
                                  self.findIndex((t) => t?.id == item?.id)
                              );

                              setProviderData(result);
                            } else {
                              setProviderData([]);
                            }

                            document
                              .querySelectorAll(".opacity-based-on-search")
                              .forEach((el) => {
                                el.style.opacity = 0.1;
                              });
                            if (input == "") {
                              document
                                .querySelectorAll(".opacity-based-on-search")
                                .forEach((el) => {
                                  el.style.opacity = 1;
                                });
                            }
                          }}
                        />
                        {(query || expand) && (
                          <span
                            className="absolute right-2 cursor-pointer text-white hover:text-white"
                            onClick={() => {
                              setQuery("");
                              setExpand(false);
                              document
                                .querySelectorAll(".opacity-based-on-search")
                                .forEach((el) => {
                                  el.style.opacity = 1;
                                });
                            }}
                          >
                            ✕
                          </span>
                        )}
                      </div>
                    </form>
                  )}
                </div>
                {(query || expand) && (
                  <div
                    className={` ${!isMobile
                      ? "middle-container bg-expand-opacity"
                      : "mobile-search-bg"
                      } `}
                  >
                    <div className=" d-flex flex-wrap justify-content-center mb-2 mx-2">
                      <div
                        className=" mb-1 p-1 m-0 search-gift  "
                        onClick={() => {
                          setSelected("all");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-0-15   border-14 cursor-pointer d-flex justify-content-between custom-shadow-btn ${selected == "all" ? "active" : ""
                            }`}
                        >
                          <div>
                            <span className="text-97a1c2 fw-semibold  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              All
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 search-gift "
                        style={{
                          width: "100px",
                        }}
                        onClick={() => {
                          setSelected("casino");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-0-15   border-14 cursor-pointer d-flex justify-content-between custom-shadow-btn ${selected == "casino" ? "active" : ""
                            } `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                alt=""
                                src={selecteCasino}
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-97a1c2 fw-semibold  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Casino
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("Casino")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 search-gift"
                        style={{
                          width: "100px",
                        }}
                        onClick={() => {
                          setSelected("live");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-0-15   border-14 cursor-pointer d-flex justify-content-between custom-shadow-btn
                            ${selected == "live" ? "active" : ""}    `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedLivesacino}
                                alt=""
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-97a1c2 fw-semibold  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Live Casino
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("Live Casino")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 search-gift"
                        style={{
                          width: "100px",
                          opacity: 0.7,
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-0-15   border-14 cursor-none d-flex justify-content-between custom-shadow-btn ${selected == "sport" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedSports}
                                alt=""
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-97a1c2 fw-semibold  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Sports
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("Sports")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 search-gift"
                        style={{
                          width: "100px",
                          opacity: 0.7,
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-0-15   border-14 cursor-none d-flex justify-content-between custom-shadow-btn ${selected == "sport" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={eSports}
                                alt=""
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-97a1c2 fw-semibold  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              E Sports
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("E Sports")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 search-gift"
                        style={{
                          width: "100px",
                          opacity: 0.7,
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-0-15   border-14 cursor-none d-flex justify-content-between custom-shadow-btn ${selected == "sport" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedSports}
                                alt=""
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-97a1c2 fw-semibold  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Mini Games
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("Mini Games")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 search-gift"
                        style={{
                          width: "100px",
                        }}
                        onClick={() => {
                          setSelected("provider");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-0-15   border-14 cursor-pointer d-flex justify-content-between ${selected == "provider" ? "custom-shadow-btn" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedSports}
                                alt=""
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-97a1c2 fw-semibold  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12">
                              Providers
                            </span>
                          </div>
                          <span
                            className="absolute top-0 right-0 bg-red-600 text-xs rounded-full fs-11 py-1"
                            style={{
                              transform: "translate(70%, -20%)",
                              color: "#f7904e",
                            }}
                          >
                            {providerData?.length}
                          </span>
                        </div>
                      </div>
                    </div>

                    {(query || expand) && (
                      <div>
                        {(selected == "all" ||
                          selected == "casino" ||
                          selected == "live" ||
                          selected == "sport") && (
                            <div
                              className={`dashboard-card leaderboard ${query.length >= 3 ? "border-gray" : ""
                                }  p-2 mx-2`}
                              style={{
                                borderRadius: "1rem",
                                height: "200px !important",
                              }}
                            >
                              {query.length >= 3 && (
                                <div
                                  className="leaderboard-scroll border-13"
                                  id="scrollable-leaderboard"
                                  style={{ maxHeight: "400px" }}
                                >
                                  <div className="d-flex mx-2">
                                    <span
                                      className="color-CCD6F6 fw-bold"
                                      style={{ fontSize: ".875rem" }}
                                    >
                                      Games
                                    </span>
                                  </div>

                                  <GameListComponent
                                    gamesWithBg1={gamesWithBg1}
                                    isLoading={isLoading}
                                    setExpand={setExpand}
                                    setQuery={setQuery}
                                  />
                                </div>
                              )}
                            </div>
                          )}

                        {(selected == "all" || selected == "provider") &&
                          providerData?.length > 0 && (
                            <div
                              className={`dashboard-card leaderboard border-gray p-2 mx-2 my-2`}
                              style={{ borderRadius: "1rem" }}
                            >
                              <div
                                className="leaderboard-scroll border-13"
                                id="scrollable-leaderboard"
                                style={{ maxHeight: "400px" }}
                              >
                                <div className="d-flex mx-2">
                                  <span
                                    className="color-CCD6F6 fw-bold"
                                    style={{ fontSize: ".875rem" }}
                                  >
                                    Providers
                                  </span>
                                </div>

                                <div className="m-2 d-flex">
                                  {providerData?.map((re, ind) => {
                                    return (
                                      <div
                                        key={ind}
                                        className="p-2 m-2 padding-10-30"
                                        style={{
                                          border: "1px solid #3a3f5c",
                                          borderRadius: ".625rem",
                                          width: "auto",
                                        }}
                                      >
                                        <p>{re?.name}</p>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              <>
                <div
                  className={`d-flex justify-content-between ${!isMobile ? "middle-container" : ""
                    } `}
                >
                  <div
                    className={`d-flex ${query || expand ? "col-12 justify-content-evenly " : ""
                      }`}
                    style={{}}
                  >
                    {/* marginLeft: "78px" */}
                    <form
                      autoComplete="off"
                      className={`${query || expand ? "col-10" : ""}`}
                    >
                      <div
                        className={`search-container px-2 ${query || expand
                          ? "transition-[width] duration-500 ease-in-out"
                          : "width-205 h-50-px"
                          }`}
                        style={{
                          transition: "width 0.2s ease-in-out",
                          ...((query || expand) && {
                            minWidth: "unset",
                            maxWidth: "unset",
                            height: "50px",
                          }),
                        }}
                      >
                        <img
                          src={Search}
                          width={15}
                          alt="search-icon"
                          className="svg-icon cursor-pointer ms-2"
                        />
                        <input
                          type="text"
                          // autoComplete="new-password"
                          name="disable-autofill"
                          className={`ps-3`}
                          value={query}
                          autoComplete="off"
                          placeholder="Main Search"
                          onClick={() => {
                            setExpand(true);
                          }}
                          onFocus={() => {
                            setExpand(true);
                          }}
                          onChange={(e) => {
                            const input = e.target.value;

                            setQuery(input);
                            setSelected("all");
                            document
                              .querySelectorAll(".opacity-based-on-search")
                              .forEach((el) => {
                                el.style.opacity = 0.1;
                              });
                            if (input == "") {
                              document
                                .querySelectorAll(".opacity-based-on-search")
                                .forEach((el) => {
                                  el.style.opacity = 1;
                                });
                            }
                            if (input.length >= 3) {
                              let result = configData?.casinoProviders?.filter(
                                (item) =>
                                  item.name
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                              );

                              result = result?.filter(
                                (item, index, self) =>
                                  index ===
                                  self.findIndex((t) => t.id == item.id)
                              );
                              setProviderData(result);
                            } else {
                              setProviderData([]);
                            }
                          }}
                        />
                        {(query || expand) && (
                          <div className="d-flex gap-3 align-items-center">
                            <span
                              className="fs-12"
                              style={{ color: "#787878" }}
                            >
                              Search requires at least 3 characters
                            </span>{" "}
                            <span
                              className="text-white cursor-pointer fs-12"
                              id="clear-search"
                              onClick={() => {
                                setQuery("");
                              }}
                            >
                              Clear
                            </span>
                            <span
                              className="absolute right-2 cursor-pointer text-white hover:text-white"
                              onClick={() => {
                                setQuery("");
                                setExpand(false);
                                document
                                  .querySelectorAll(".opacity-based-on-search")
                                  .forEach((el) => {
                                    el.style.opacity = 1;
                                  });
                              }}
                            >
                              ✕
                            </span>
                          </div>
                        )}
                      </div>
                    </form>

                    <div
                      className={`app-navbar-item ms-1  align-self-center me-2 ${query || expand ? "col-2 custom-btn-width" : "ms-md-2"
                        }`}
                    >
                      <div
                        className="d-flex box-purple text-white text-white-btn 
                           fs-11 rakebacks-btn align-self-center cursor-pointer align-items-center rakeback-remove-hover"
                        style={{
                          background: "#6916cb",
                          borderRadius: "30px",
                          boxShadow: "inset 0 0 10px #282d39",
                          height: "47px",
                          color: "#fff",
                        }}
                        onClick={() => {
                          if (profileData) {
                            setIsRakebackModalOpen(true);
                          } else {
                            setLoginOpen(!isLoginOpen);
                          }
                        }}
                      >
                        <svg
                          width="24"
                          height="18"
                          viewBox="0 0 24 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="profile-menu-icon"
                        >
                          <path
                            d="M2.12799 12.7321C1.67176 9.7666 1.21554 6.80117 0.759311 3.83567C0.658136 3.1783 1.40611 2.72995 1.93816 3.12902C3.35956 4.19507 4.78089 5.26105 6.20229 6.3271C6.67029 6.6781 7.33704 6.56387 7.66149 6.07712L11.2115 0.752122C11.5866 0.189397 12.4134 0.189397 12.7886 0.752122L16.3385 6.07712C16.663 6.56387 17.3297 6.67802 17.7977 6.3271C19.2191 5.26105 20.6405 4.19507 22.0619 3.12902C22.5939 2.72995 23.3419 3.1783 23.2408 3.83567C22.7846 6.80117 22.3283 9.7666 21.8721 12.7321H2.12799Z"
                            fill="#FFB743"
                          />
                          <path
                            d="M20.8427 17.6676H3.15737C2.58887 17.6676 2.12799 17.2067 2.12799 16.6382V14.377H21.8721V16.6382C21.872 17.2067 21.4112 17.6676 20.8427 17.6676Z"
                            fill="#FFB743"
                          />
                        </svg>

                        <span className="ms-2 fs-11 rakeback-remove-hover">
                          Rakeback
                        </span>
                      </div>
                    </div>
                  </div>

                  {!expand && (
                    <div className="app-navbar d-flex cursor-pointer flex-shrink-0 ">
                      <div className="d-flex mt-2 mt-xs-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
                        {profileData?.user && (
                          <div className="app-navbar-item ms-1 ms-md-2 align-self-center me-2">
                            <span
                              className="box-green wallet-btn text-black text-white-btn  fs-11 py-3 align-self-center cursor-pointer header-wallet"
                              onClick={() => {
                                setIsWalletOpen(true);
                              }}
                              style={{
                                height: "47px",
                                borderRadius: "30px",
                                padding: "0px 32px",
                                background:
                                  "linear-gradient(to bottom, rgb(0, 150, 65), rgb(0, 236, 102))",
                              }}
                            >
                              Wallet
                            </span>
                          </div>
                        )}

                        {profileData?.user && (
                          <div
                            className="btn my-account py-0 align-self-center custom-button-hover"
                            style={{
                              minHeight: "45px",
                              maxHeight: "50px",
                              // width: "200px",
                              gap: "0px",
                            }}
                          >
                            <div className="d-flex align-items-center gap-2 justify-content-center me-4">
                              <IoMdRefresh
                                size={24}
                                className={`text-light cursor-pointer ${refreshing ? "animate-spin" : ""
                                  }`}
                                onClick={handleRefreshClick}
                              />
                              <span className="username">
                                {new Intl.NumberFormat("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(
                                  balance ||
                                  profileData?.user?.usable_coin_balance ||
                                  0
                                )}
                              </span>
                            </div>
                            <img
                              src={INR}
                              width={18}
                              height={18}
                              alt=""
                              className="svg-icon svg-icon-2 text-center"
                            />
                          </div>
                        )}

                        {profileData?.user?.notification && (
                          <div
                            className="app-navbar-item ms-1 ms-md-3 align-self-center"
                            onClick={() => {
                              openNotification();
                            }}
                          >
                            <div
                              className="btn my-account py-0 align-self-center"
                              style={{
                                minHeight: "50px",
                                maxHeight: "50px",
                                borderRadius: "50%",
                                width: "50px",
                              }}
                            >
                              <img
                                src={Notification}
                                width={22}
                                alt=""
                                height={22}
                                className="svg-icon svg-icon-2 text-center"
                              />
                            </div>
                          </div>
                        )}

                        {profileData?.user && (
                          <div
                            className="app-navbar-item ms-1 ms-md-3 align-self-center"
                            onClick={() => {
                              navigate("/profile-dashboard/gifts");
                            }}
                          >
                            <div
                              className="btn my-account py-0 custom-button-hover d-flex align-items-center gap-2"
                              style={{
                                minHeight: "50px",
                                maxHeight: "50px",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                              }}
                            >
                              <img
                                src={Gifting}
                                width={22}
                                height={22}
                                alt=""
                                className="svg-icon svg-icon-2"
                              />

                              <span
                                className="username"
                                style={{
                                  color: "#9da3b2",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {giftWalletBalance?.toFixed(2) || 0}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div
                        className="notification-panel"
                        id="notificationPanel"
                      >
                        <div className="notification-header">
                          <h2 className="fw-bold hero-heading">
                            Notifications
                          </h2>
                          <button
                            className="close-btn"
                            onClick={() => {
                              closeNotification();
                            }}
                          >
                            ×
                          </button>
                        </div>
                        <div className="notification-content">
                          {notifications.map((itm, index) => (
                            <div
                              key={index}
                              className="notification-item cursor-pointer "
                              onClick={() => {
                                handleMarkSeen(false, itm.userNotificationId);
                              }}
                            >
                              <span className="fs-14 text-white">
                                <span className="fw-semibold">{itm.title}</span>
                                <br />
                                <span className="">{itm.description}</span>
                              </span>
                              <div className="d-flex justify-content-between">
                                <span className="w-100 fs-11 text-white opacity-50">
                                  {getReadableDate(itm.createdAt)}
                                </span>
                                <span className="w-100 fs-11 text-purple cursor-pointer text-end">
                                  Mark as read
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {profileData ? (
                        <div className="app-navbar-item ms-md-2 align-self-center">
                          <div
                            className="cursor-pointer symbol symbol-30px symbol-md-40px"
                            onMouseEnter={() => {
                              setHoverProfile((prev) => !prev); // toggle on click
                              setHoverTheme(false);
                            }}
                          >
                            <div
                              className="btn my-account cursor-pointer profile-btn"
                              style={{ minHeight: "47px", maxHeight: "50px" }}
                            >
                              <span
                                className="username"
                                style={{ fontSize: "12px" }}
                                onClick={() => {
                                  navigate("/profile-dashboard/dashboard");
                                }}
                                onMouseEnter={() => {
                                  setHoverProfile(true);
                                }}
                              >
                                {profileData?.user?.username}
                              </span>
                              <div className="icon">
                                <img
                                  src={UserProfile}
                                  alt="my account"
                                  style={{
                                    borderRadius: "50%",
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                              </div>
                              <div>
                                <MdKeyboardArrowDown />
                              </div>
                            </div>
                          </div>

                          {hoverProfile && (
                            <div
                              className="menu menu-sub menu-sub-dropdown menu-gray-800 py-3 pb-2 mt-3 fs-6"
                              onMouseLeave={() => {
                                setHoverProfile((prev) => !prev); // toggle on click
                                setHoverTheme(true);
                              }}
                              onClick={(e) => {
                                e.nativeEvent.stopImmediatePropagation();
                              }}
                              style={{ zIndex: 999 }}
                            >
                              {sideBarListNew.map((item, idx) => (
                                <div key={idx} className="mb-2 cursor-pointer">
                                  {/* <div className="separator my-1"></div> */}

                                  <div
                                    className={`menu-item px-2 py-1 mx-2 d-flex ${item.label == currentPage
                                      ? "active side-link"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      if (
                                        item.name == "deposit" ||
                                        item.name == "withdraw" ||
                                        item.name == "buy-crypto"
                                      ) {
                                        setIsWalletOpen(true);
                                      } else if (item.name == "rakeback") {
                                        setIsRakebackModalOpen(true);
                                      } else {
                                        handleSidebarClick(item);
                                      }
                                      setHoverProfile((prev) => !prev);
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-2  ">
                                      {item.img}
                                    </span>
                                    <span className="menu-link fs-14 px-2">
                                      {item?.label}
                                    </span>
                                  </div>
                                </div>
                              ))}

                              {/* <div className="separator my-1"></div> */}
                              <hr />

                              <div
                                className="menu-item-logout px-2 py-1 mx-2 d-flex"
                                onClick={() => {
                                  handleSignout();
                                }}
                              >
                                <span className="svg-icon svg-icon-2  ">
                                  <img
                                    src={Logout}
                                    alt="icon"
                                    width={23}
                                    height={23}
                                    className="svg-icon"
                                  />
                                </span>
                                <span className="menu-link fs-14 px-2">
                                  Logout
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                            <span
                              className="text-white-btn fs-11 login-btn align-self-center cursor-pointer "
                              style={{
                                border: "1px solid white",
                                borderRadius: "20px",
                              }}
                              onClick={() => {
                                setLoginOpen(true);
                              }}
                            >
                              {t("SignUpPage.login")}
                            </span>
                          </div>
                          <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                            <span
                              className="box-green-faded text-white-btn  fs-11 register-btn align-self-center cursor-pointer"
                              onClick={() => {
                                setSignupOpen(true);
                              }}
                            >
                              Register
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
                {(query || expand) && (
                  <div
                    className={` ${!isMobile ? "middle-container bg-expand-opacity" : ""
                      } `}
                  >
                    <div className=" d-flex flex-wrap mb-2 mt-2 justify-content-evenly">
                      <div
                        className=" mb-1 p-1 m-0 gift "
                        onClick={() => {
                          setSelected("all");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-24px-28px   border-14 cursor-pointer d-flex justify-content-between custom-shadow-btn ${selected == "all" ? "active" : ""
                            }`}
                        >
                          <div>
                            <span className="text-white  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              All
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 gift "
                        style={{}}
                        onClick={() => {
                          setSelected("casino");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-24px-28px   border-14 cursor-pointer d-flex justify-content-between custom-shadow-btn ${selected == "casino" ? "active" : ""
                            } `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                alt=""
                                src={selecteCasino}
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-white  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Casino
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            { }
                            {findCategoryCount("Casino")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 gift "
                        style={{}}
                        onClick={() => {
                          setSelected("live");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-24px-28px   border-14 cursor-pointer d-flex justify-content-between custom-shadow-btn ${selected == "live" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedLivesacino}
                                alt="icon"
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-white  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Live Casino
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("Live Casino")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 gift "
                        style={{ opacity: 0.7 }}
                      >
                        <div
                          className={`btn relative my-account padding-24px-28px   border-14 cursor-none d-flex justify-content-between custom-shadow-btn ${selected == "sport" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedSports}
                                alt="icon"
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-white  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Sports
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("Sports")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 gift "
                        style={{ opacity: 0.7 }}
                      >
                        <div
                          className={`btn relative my-account padding-24px-28px   border-14 cursor-none d-flex justify-content-between custom-shadow-btn ${selected == "sport" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={eSports}
                                alt="icon"
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-white  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              E Sports
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("E Sports")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 gift "
                        style={{ opacity: 0.7 }}
                      >
                        <div
                          className={`btn relative my-account padding-24px-28px   border-14 cursor-none d-flex justify-content-between custom-shadow-btn ${selected == "sport" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedSports}
                                alt="icon"
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-white  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Mini Games
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {findCategoryCount("Mini Games")}
                          </span>
                        </div>
                      </div>
                      <div
                        className=" mb-1 p-1 m-0 gift "
                        style={{}}
                        onClick={() => {
                          setSelected("provider");
                        }}
                      >
                        <div
                          className={`btn relative my-account padding-24px-28px   border-14 cursor-pointer d-flex justify-content-between custom-shadow-btn ${selected == "provider" ? "active" : ""
                            }
                                `}
                        >
                          {window.innerWidth > 1028 && (
                            <div>
                              <img
                                draggable="false"
                                loading="lazy"
                                src={selectedSports}
                                alt="icon"
                              />
                            </div>
                          )}
                          <div>
                            <span className="text-white  mx-0 mx-sm-0 mx-md-2 mx-lg-2 fs-12 custom-shadow-span">
                              Providers
                            </span>
                          </div>
                          <span className="absolute custom-shadow-num bg-red-600 text-xs rounded-full py-1">
                            {providerData?.length}
                          </span>
                        </div>
                      </div>
                    </div>

                    {(query || expand) && (
                      <div className="col-12 d-flex">
                        {(selected == "all" ||
                          selected == "casino" ||
                          selected == "live" ||
                          selected == "sport") && (
                            <div
                              className={`dashboard-card leaderboard ${query.length >= 3 ? "border-gray" : ""
                                }  p-2 mx-2 ${selected == "all" && providerData?.length > 0
                                  ? "col-8 w-75"
                                  : "col-12 w-100"
                                }`}
                              style={{ borderRadius: "1rem" }}
                            >
                              {query.length >= 3 && (
                                <div
                                  className="leaderboard-scroll border-13"
                                  id="scrollable-leaderboard"
                                  style={{ maxHeight: "400px" }}
                                >
                                  <div className="d-flex mx-2">
                                    <span
                                      className="color-CCD6F6 fw-bold"
                                      style={{ fontSize: ".875rem" }}
                                    >
                                      Games
                                    </span>
                                  </div>
                                  <GameListComponent
                                    gamesWithBg1={gamesWithBg1}
                                    isLoading={isLoading}
                                    setExpand={setExpand}
                                    setQuery={setQuery}
                                  />
                                </div>
                              )}
                            </div>
                          )}

                        {(selected == "all" || selected == "provider") &&
                          providerData?.length > 0 && (
                            <div
                              className={`dashboard-card leaderboard border-gray p-2 mx-2  ${selected == "all" && providerData.length > 0
                                ? "col-2 w-25"
                                : selected == "provider" &&
                                  providerData.length > 0
                                  ? "col-12 w-100"
                                  : ""
                                }`}
                              style={{
                                borderRadius: "1rem",
                                minHeight:
                                  selected == "all"
                                    ? "300px"
                                    : "fit-content !important",
                              }}
                            >
                              <div
                                className="leaderboard-scroll border-13"
                                id="scrollable-leaderboard"
                                style={{ maxHeight: "400px" }}
                              >
                                <div className="d-flex mx-2">
                                  <span
                                    className="color-CCD6F6 fw-bold"
                                    style={{ fontSize: ".875rem" }}
                                  >
                                    Providers
                                  </span>
                                </div>

                                <div className="m-2 d-flex">
                                  {providerData.map((re, ind) => {
                                    return (
                                      <div
                                        className="p-2 m-2 padding-10-30"
                                        style={{
                                          border: "1px solid #3a3f5c",
                                          borderRadius: ".625rem",
                                          width: "auto",
                                          minHeight: selected
                                            ? "auto !important"
                                            : "",
                                        }}
                                      >
                                        <p>{re?.name}</p>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </nav>
          {window.innerWidth < 1024 && (
            <div
              className="bottom-nav"
              style={{ zIndex: "999999999999999 !important" }}
            >
              {
                !isSportGame && (
                  <ul>
                    {navItems.map((item, index) => (
                      <li
                        key={index}
                        className={activeIndex == index ? "active" : ""}
                        style={{ "--color": item.color }}
                        onClick={(e) => {
                          setActiveIndex(index);
                          handleAllTabClick(item, e);
                        }}
                      >
                        <Link
                        // to={item.link}
                        >
                          <img
                            loading="lazy"
                            src={
                              activeIndex == index
                                ? item.selectedIcon
                                : item.icon
                            }
                            alt={item?.label?.toLowerCase()}
                            style={{
                              filter:
                                activeIndex == index
                                  ? `drop-shadow(0 0 8px ${item.color})`
                                  : "",
                            }}
                          />
                          <span value={item.textKey}>{item.label}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )
                // : (
                //   <ul>
                //     {navSportsItems.map((item, index) => (
                //       <li
                //         key={index}
                //         className={activeIndex == index ? "active" : ""}
                //         style={{ "--color": item.color }}
                //         onClick={(e) => {
                //           setActiveIndex(index);
                //           handleAllTabClick(item, e);
                //         }}
                //       >
                //         <Link
                //         // to={item.link}
                //         // onClick={(e) => handleAllTabClick(item, e)}
                //         >
                //           <img
                //             loading="lazy"
                //             src={
                //               activeIndex == index
                //                 ? item.selectedIcon
                //                 : item.icon
                //             }
                //             alt={item?.label?.toLowerCase()}
                //             style={{
                //               filter:
                //                 activeIndex == index
                //                   ? `drop-shadow(0 0 8px ${item.color})`
                //                   : "",
                //             }}
                //           />
                //           <span value={item.textKey}>{item.label}</span>
                //         </Link>
                //       </li>
                //     ))}
                //   </ul>
                // )
              }
            </div>
          )}
          <PlayModePopup
            isOpen={isPopupOpen}
            onClose={() => setIsPopupOpen(false)}
            onSelect={handlePlayModeSelect}
            selectedGame={selectedGame}
          />

          {profileData?.user?.isDemoUser && (
            <h4 className="w-100 text-center text-white bg-purple">
              <span className="m-auto">Yor are logged in as a Demo user. </span>
            </h4>
          )}
        </div>
      </div>

      {isLoginOpen && (
        <LoginModal
          open={isLoginOpen}
          setOpen={setLoginOpen}
          switchToSignup={switchToSignup}
          // onLoginSuccess={handleLoginSuccess}
          openForgotPINModal={() => {
            setLoginOpen(false);
            setForgotPINOpen(true);
          }}
        />
      )}

      {isForgotPINOpen && (
        <ForgotPINModal
          open={isForgotPINOpen}
          setOpen={setForgotPINOpen}
          openLoginModal={() => {
            setLoginOpen(true);
            setForgotPINOpen(false);
          }}
        />
      )}

      {isWalletOpen && (
        <WalletModal
          open={isWalletOpen}
          setOpen={setIsWalletOpen}
          mfaOpen={isMFAOpen}
          setmfaOpen={setIsMFAOpen}
        />
      )}

      {isSignupOpen && (
        <SignupModal
          open={isSignupOpen}
          setOpen={setSignupOpen}
          switchToLogin={switchToLogin}
        />
      )}

      {<MFAModal open={isMFAOpen} setOpen={setIsMFAOpen} fromDirect={false} />}

      {isRakebackModalOpen && (
        <RakebackModal
          open={isRakebackModalOpen}
          setOpen={closeRakebackModal}
        />
      )}

      {logoutModal && (
        <LogoutModal open={logoutModal} setOpen={setLogoutModal} />
      )}
    </div>
  );
};

HumburgerMenu.prototype = {
  menuOpen: PropTypes.bool,
  setMenuOpen: PropTypes.func,
};

export default HumburgerMenu;
